import { h } from "@stencil/core";
export class ChStepList {
    el;
    ulStep;
    render() {
        return (h("div", { key: 'f3ac40ce18e8ea5de7bc9d4ad4cd04d157af4c4c', class: "step-container" }, h("ul", { key: '2a28c766411dcf9d8a6cefae2f6dd48f1695a75d', ref: el => (this.ulStep = el) }, h("slot", { key: 'ef96096aec88223fa44d654527df745e6004f73e' }))));
    }
    static get is() { return "ch-step-list"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["ch-step-list.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["ch-step-list.css"]
        };
    }
    static get elementRef() { return "el"; }
}
